import { css } from 'linaria';

export const wrapper = css`
  display: flex;
  gap: var(--space-100);
  padding: var(--space-225) var(--space-200);
  border-radius: var(--rounding-l);
  box-shadow: var(--box-shadow-m);
`;

export const description = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-50);
`;
